<template>
  <div>
    <a-upload
      name="avatar"
      :show-upload-list="false"
      :customRequest="uploadImg"
      :before-upload="beforeUpload"
      @change="handleChange"
      accept="video/mp4">
      <div>
        <a-button> <a-icon :type="loading ? 'loading' : 'upload'" />点击上传</a-button>
      </div>
    </a-upload>
    <div>
      <video controls style="width: 50%" v-if="audioUrl || defaultUrl" :src="audioUrl || defaultUrl" />
    </div>
  </div>
</template>
<script>
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}
const OSS = require('ali-oss')
import OssApi from '../../../api/src/oss/api/OssApi'
const ossApi = new OssApi()
export default {
  name: 'VideoUpload',
  props: {
    path: String,
    defaultUrl: String
  },
  data() {
    return {
      loading: false,
      audioUrl: '',
    };
  },
  methods: {
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true;
        return;
      }
      // if (info.file.status === 'done') {
      //   // Get this url from response in real world.
      //   getBase64(info.file.originFileObj, imageUrl => {
      //     this.imageUrl = imageUrl;
      //     this.loading = false;
      //   });
      // }
    },
    async beforeUpload(file) {
      console.log(file.type)
      const isJpgOrPng = file.type === 'video/mp4';
      if (!isJpgOrPng) {
        this.$message.error('只能上传 MP4 文件!');
      }
      // const isLt2M = file.size / 1024 / 1024 < 2;
      const isLt2M = true
      if (!isLt2M) {
        this.$message.error('文件必须小于 200MB!');
      }
      return isJpgOrPng && isLt2M;
    },
    async uploadImg(info) {
      console.log(info)
      let res = await ossApi.getStsAkTextbookEditor(this.path)
      console.log(res)
      let region = res.endpoint;
      let fKey = region.indexOf('//') + 2;
      let lKey = region.indexOf('.');
      let client = new OSS({
        region: region.substring(fKey,lKey),
        accessKeyId: res.accessKeyId,
        accessKeySecret: res.accessKeySecret,
        stsToken: res.securityToken,
        bucket: res.bucketName,
      })

      let tempCheckpoint;
      client.multipartUpload(`${res.url}${info.file.uid}.mp4` , info.file, {
        progress: (p, checkpoint) => {
          // 断点记录点。浏览器重启后无法直接继续上传，您需要手动触发上传操作。
          tempCheckpoint = checkpoint;
          console.log(p, checkpoint)
          if(p == 1){
            let endpointPath = res.endpoint.split('/')
            let endpoint = endpointPath[endpointPath.length - 1]
            let url
            if(checkpoint){
              url = `https://${res.bucketName}.${endpoint}/${checkpoint.name}`;
            }else{
              url = `https://${res.bucketName}.${endpoint}/${res.url}${info.file.uid}.mp4`
            }
            console.log(url)
            info.file.status = 'done'
            this.$emit('changeUri', `${res.url}${info.file.uid}.mp4`)
            this.audioUrl = url;
            this.loading = false;
            setTimeout(() => {
              this.$emit('changeUri', `${res.url}${info.file.uid}.mp4`)
              this.audioUrl = url;
              this.loading = false;
            }, 1000)
          }
        },
      }).catch(err => {
        console.log(err)
      })
    },
  },
};
</script>
<style>
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>